import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { EmployeeTabs } from "./EmployeeTabs";

export function ShowEmployeeInformation({ user, userAccessData, employeePhoto, setEmployeePhoto }) {
  return (
    <div className="EmployeeInfo shadow-xl">
      <div className="EmployeeList">
        <div className="Header">
          <div className="titleContainer row">
            <PeopleAltIcon style={{ padding: "0 10px 0 0" }} />
            <h3>List Of Employee</h3>
          </div>
        </div>
        <div className="employeeTabs">
          {/* 
             This component is now Smart. 
             It no longer needs employees or filters passed from Home.js 
          */}
          <EmployeeTabs
            user={user}
            userAccessData={userAccessData}
            employeePhoto={employeePhoto}
            setEmployeePhoto={setEmployeePhoto}
          />
        </div>
      </div>
    </div>
  );
}